import { Toast } from 'antd-mobile'
// import wx from 'weixin-js-sdk'
import md5 from 'js-md5'
import history from './history'
import loginModel from '@/model/login'
import ownSensors from '@/utils/sensorsPonint'
import iconPinDao from '@/assets/default/img_pindao.png'
import iconPinDaoFenLei from '@/assets/default/img_pindaofenglei.png'
import iconLanMu from '@/assets/default/img_lanmu.png'
import iconLunWen from '@/assets/default/img_lunwen.png'
import iconZiLanMu from '@/assets/default/img_zilanmu.png'
import avatarDoctor from '@/assets/default/avatar_doctor.png'
import avatarHospital from '@/assets/default/avatar_hospital.png'
import avatarKeshi from '@/assets/default/avatar_keshi.png'
import avatarQsyg from '@/assets/default/avatar_qsyg.png'
import imgBook from '@/assets/default/img_book.png'
import iconZhiBo from '@/assets/channel/icon_zhibo.png'
import iconHuaTi from '@/assets/channel/icon_huati.png'
import iconPeiXun from '@/assets/channel/icon_peixun.png'
import iconImg from '@/assets/channel/icon_img.png'
import iconTaoLunZu from '@/assets/channel/home_icon_taolunzu.png'
import iconZhuanJi from '@/assets/channel/img-zhuanji.png'
import iconWaiLian from '@/assets/channel/icon_wailian.png'
import iconPinDaoOther from '@/assets/channel/icon_pindao.png'
import qs from 'qs'

const CryptoJS = require('crypto-js')

export const toast = (content = '', icon = 'loading', duration = 0) => {
  Toast.show({
    content,
    icon,
    maskClickable: false,
    duration,
  })
}

export const clearToast = () => {
  Toast.clear()
}

export const zeroFill = (i) => {
  if (i >= 0 && i <= 9) return `0${i}`
  return i
}

export const getCurrentTime = () => {
  let date = new Date() // 当前时间
  let year = date.getFullYear() // 年
  let month = zeroFill(date.getMonth() + 1) // 月
  let day = zeroFill(date.getDate()) // 日
  let hour = zeroFill(date.getHours()) // 时
  let minute = zeroFill(date.getMinutes()) // 分
  let second = zeroFill(date.getSeconds()) // 秒
  let millSecond = zeroFill(date.getMilliseconds()) // 毫秒

  return `${year}-${month}-${day} ${hour}:${minute}:${second}.${millSecond}`
}
export function getCurrentTimeMinute () {
  let date = new Date() // 当前时间
  let year = date.getFullYear() // 年
  let month = zeroFill(date.getMonth() + 1) // 月
  let day = zeroFill(date.getDate()) // 日
  let hour = zeroFill(date.getHours()) // 时
  let minute = zeroFill(date.getMinutes()) // 分
  return `${year}-${month}-${day} ${hour}:${minute}`
}

// 生成 oss 上传目录
export const createUploadCatalogue = (type, fileName) => {
  if (!['image', 'file', 'video'].includes(type)) return Promise.reject('类型错误')

  let date = new Date() // 当前时间

  let _index = fileName.lastIndexOf('.')
  if (_index === -1) return Promise.reject('文件后缀名异常')

  let _fileName = fileName.slice(0, _index) // 文件名
  let suffix = fileName.substring(_index) // 文件后缀

  // 文件名加密规则：文件名 + 时间戳（到毫秒）+ 1000 随机数
  let md5FileName = getMd5(
    `${_fileName}${date.valueOf()}${Math.random() * 1000}`
  )
  let year = date.getFullYear()
  let month = zeroFill(date.getMonth() + 1) // 月
  let day = zeroFill(date.getDate()) // 日

  return `${type}/${year}${month}${day}/${md5FileName}${suffix}`
}

export const getMd5 = (str) => {
  md5(str)
  let hash = md5.create()
  hash.update(str)
  return hash.hex()
}

export const getQueryString = (name) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'iu')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export const getlinkUrlParams = (url, key) => {
  let reg = /(?!(?:(\?|&)))([\u4e00-\u9fa5\w]+)=([\u4e00-\u9fa5\w]+)/gu
  let arr = url.match(reg)
  let obj = {}
  if (arr && arr.length) {
    obj = arr.reduce((acc, v) => {
      let [key, value] = v.split('=')
      acc[key] = value
      return acc
    }, {})
  }
  if (key) {
    return obj[key]
  }
  return obj
}

export const backUrl = (isSavaUrl = true, isWxLogin = true, isRedirectLoginPage = true) => {
  if (isSavaUrl) {
    const querys = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    Reflect.deleteProperty(querys, 'code')
    console.log('存储URL Parms', querys)
    window.localStorage.setItem('url', `${window.location.origin}${window.location.pathname}?${qs.stringify(querys)}`)
  }

  if (
    !window.localStorage.getItem('token') ||
    window.localStorage.getItem('token') === ''
  ) {
    if (isWeixin() && isWxLogin) {
      return h5Login('snsapi_base', window.localStorage.getItem('url'), isRedirectLoginPage)
    }
    if (isRedirectLoginPage) {
      console.log('登录-判断isRedirectLoginPage')
      return history.push('/login')
    }
  }
}

export const judgeToken = () => {
  if (
    (!window.localStorage.getItem('token') ||
    window.localStorage.getItem('token') === '' ||
    getQueryString('code')) && isWeixin()
  ) {
    return false
  }
  return true
}

// 微信H5登录
export const h5Login = (snsapi, redirectUrl, isRedirectLoginPage = true) => {
  let appid = process.env.REACT_APP_WECHAT_APP_ID
  let redirect = encodeURIComponent(redirectUrl)
  let wxCode = getQueryString('code')
  if (wxCode) {
    window.localStorage.setItem('wxCodeData', JSON.stringify({
      snsapi,
      wxCode
    }))
    if (snsapi === 'snsapi_base') {
      h5CodeLogin(wxCode, appid, isRedirectLoginPage)
    }
  } else {

    return window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=${snsapi}&state=type`
  }
  //   scope=snsapi_userinfo / snsapi_base静默
}

const h5CodeLogin = (code, appid, isRedirectLoginPage = true) => {
  let redirect = encodeURIComponent(isRedirectLoginPage ?  process.env.REACT_APP_H5_DOMAIN + '/login' : window.localStorage.getItem('url'))
  loginModel.h5toWechtLogin({data: {
    loginType: '4',
    loginName: '',
    phoneVerifyCode: '',
    site: '1',
    loginPwd: '',
    code,
  }}).then(({datas}) => {
    console.log(datas, '======h5CodeLogin====')
    ownSensors.loginResultSuccessAsyn(datas, {is_first_login: false, type: 'wx'}).then(_ => {
      window.localStorage.setItem('token', datas.tokenValue)
      window.localStorage.setItem('userInfo', JSON.stringify(datas))
      Toast.show({content: '登录成功', icon: 'success'})
      localStorage.removeItem('wxCodeData')
      window.location.href = window.localStorage.getItem('url')
    })
    window.localStorage.setItem('back_url_login', true)
  }).catch((error) => {
    console.log(error, 'error')
    if (error?.code === '100006033') {
      window.localStorage.setItem('back_url_login', true)
    }
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=type`

  })

}

// 判断是否在微信打开
export const isWeixin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') !== -1) {
    return true
  }
  return false
}

// Y年 M月 D日 h时 m分 s秒
export  const getStrDate = (time, type = 'MDhm') => {
  const dataStr = new Date(time)
  switch (type) {
    case 'MDhm':
      return `${dataStr.getFullYear() + 1}年${dataStr.getMonth() + 1}月${dataStr.getDate()}日`
    default:
  }
}
export const getParamsTime = (time) => {
  console.log('===33->>>', time)
  time = time.replace(/年|月|日/gu, '/')
  time =
    time.substring(time.length - 1) === '/'
      ? time.substring(0, time.length - 1)
      : time
  // console.log('==55=->>>', time)
  let date = new Date(time) // 当前时间
  let year = date.getFullYear() // 年
  let month = zeroFill(date.getMonth() + 1) // 月
  return `${year}.${month}`
}
// YYYY-MM-DD HH:mm:ss
export const getFormatDate = (format, time) => {
  format === 'default' && (format = 'YYYY-MM-DD HH:mm:ss')
  let date =
    (time && (time = time.replace(/-/gu, '/')) && new Date(time)) || new Date()
  console.log('***********->>>', date)
  let year = date.getFullYear() // 年
  let month = zeroFill(date.getMonth() + 1) // 月
  let day = zeroFill(date.getDate()) // 日
  let hour = zeroFill(date.getHours()) // 时
  let minute = zeroFill(date.getMinutes()) // 分
  let second = zeroFill(date.getSeconds()) // 秒
  return format
    .replace(/YYYY/gu, year)
    .replace(/MM/gu, month)
    .replace(/DD/gu, day)
    .replace(/HH/gu, hour)
    .replace(/mm/gu, minute)
    .replace(/ss/gu, second)
}

export const numberToStr = (num, unit = 'W') => {
  if (isNaN(num))  return ''
  let numStr = num + ''
  let numStrLength = numStr.length
  if (numStrLength < 5) {
    return numStr
  }
  num /= 10000
  return isNaN(num) ? '' : num.toFixed(1) + unit
}

export const markRightNumber = (num) => {
  let numStr = num + ''
  let numStrLength = numStr.length
  if (numStrLength < 4) {
    return numStr
  } else if (numStrLength === 4) {
    return numStr.substring(0, 1) + 'K+'
  } else if (numStrLength > 5) {
    return '9W+'
  }
  return numStr.substring(0, 1) + 'W+'
}

// 防抖
export const debounce = (fun, delay) => {
  let timer = null
  return function (args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fun.call(this, args)
    }, delay)
  }
}

export const encryptWithAES = (str) => {
  let secretKey = process.env.NODE_ENV === 'production' ? '%boaoap^32w00000' : '%boaoap^32w00000'
  let key = CryptoJS.enc.Utf8.parse(secretKey)
  let encrypted = CryptoJS.AES.encrypt(str, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  return encrypted.ciphertext.toString()
}

export const getImgNaturalDimensions = (oImg) => new Promise((resolve, reject) => {
  try {
    if (!oImg) return new Error('Error: getImgNaturalDimensions => no oImg')
    const isLoaded = oImg.complete
    if (isLoaded) reject(new Error('Info: getImgNaturalDimensions => oImg is loaded, get information from cache or memory'))
    oImg.onload = () => {
      let imageInfo = {w: 0, h: 0}
      if (oImg.naturalWidth) {
        // 现代浏览器
        imageInfo = {w: oImg.naturalWidth, h: oImg.naturalHeight}
        return resolve(imageInfo)
      }
      // IE6/7/8
      imageInfo = {w: oImg.width, h: oImg.height}
      return resolve(imageInfo)
    }
    oImg.onerror = (error) => reject(new Error(`Error: onload failed => ${error}`))
  } catch (error) {
    return new Error(`Error: getImgNaturalDimensions => ${error}`)
  }
})

export const handleParse = (objStr) => new Promise((resolve, reject) => {
  try {
    if (typeof objStr !== 'string') {
      console.info(new Error('Error: handleParse ->> params is not string'))
      return resolve([])
    }
    if (!objStr) return resolve([])
    const obj = JSON.parse(objStr)
    resolve(obj)
  } catch (error) {
    console.info(new Error('Error: handleParse ->> jsonParse failed'))
    resolve([])
  }
})

// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容 updateAppMessageShareData (onMenuShareAppMessage 即将废弃)
// 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容 updateTimelineShareData （onMenuShareTimeline 即将废弃）
export const shareWithinWeChat = (_title, _imgUrl, _desc = '', successCallback, shareUrl) => {
  // _imgUrl可传账号类型（使用默认头像）： accountType 账号类型 1.医院 2.科室 3.医生11.商务
  let url = shareUrl || window.location.href
  console.log('二次分享-url',  'url=>', url)
  console.log('二次分享-标题',  'title=>', _title)
  console.log('二次分享-缩略图',  'imgUrl=>', _imgUrl)
  console.log('二次分享-描述',  'desc=>', _desc)
  switch (_imgUrl) {
    case 1: // 医院默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/c561b603333dc4f613d43728175a3ed6.png'
      break
    case 2: // 科室默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/fcaa12f9218bdad34252a8e31df9271b.png'
      break
    case 3: // 医生默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/e48e97223414fc2460ddffd569f33eeb.png'
      break
    case 11: // 商务默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/97c15bca9bbdcda05b4a3d4c3ece0a40.png'
      break
    case 12: // 书籍默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/b2f715140d8b765fb71a3c86267e9101.png'
      break
    case 13: // 论文默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/cdb669ea050d253bb015a79387070b3f.png'
      break
    case 14: // 专辑默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/10c3135aab7c2637dc130497b8e56abe.png'
      break
    case 15: // 直播默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/%E7%9B%B4%E6%92%AD%E9%A2%84%E5%91%8A%402x.png'
      break
    case 16: // 术友圈图文 - 默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image_%E5%9B%BE%E6%96%87%402x.png'
      break
    case 17: // 术友圈文章 - 默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image_%E6%96%87%E7%AB%A0%402x.png'
      break
    case 18: // 话题 - 默认图
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image_topic.png'
      break
    case 99: // 默认 - 博鳌医学logo
      _imgUrl = 'https://boao-prod.oss-cn-shanghai.aliyuncs.com/image/20221215/logo.png'
      break
    default:
  }
  window.$wx?.ready(function () {   // 需在用户可能点击分享按钮前就先调用
    console.log('ready')
    const shareObj = {
      title: _title ? _title?.substr(0, 100) : '', // 分享标题  跟app保持一致 只有100个文字
      desc: _desc ? _desc.substr(0, 100) : '', // 分享描述 .substr(0, 100)
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl: _imgUrl, // 分享图标 必传
      success: function () {
        // 设置成功
        console.log('设置成功')
        successCallback && successCallback()
      },
      fail: function (err) {
        // 设置失败
        console.log('设置失败', err)
      }
    }
    if (window.$wx.updateAppMessageShareData) {
      window.$wx.updateAppMessageShareData(shareObj)
    } else {
      window.$wx.onMenuShareAppMessage(shareObj)
    }
    if (window.$wx.updateTimelineShareData) {
      window.$wx.updateTimelineShareData(shareObj)
    } else {
      window.$wx.onMenuShareTimeline(shareObj)
    }
  })
}

// 频道 如果封面图为空的时候，通过type获取封面图
export const getDefaultImg = (type) => {
  let kvFileUrl = null
  switch (type) {
    case '1': // 医生
    case 'A': // 专辑列表
    case 'D': // 出版物列表
      kvFileUrl = avatarDoctor
      break
    case '2': // 科室
      kvFileUrl = avatarKeshi
      break
    case '3': // 医院
      kvFileUrl = avatarHospital
      break
    case 'J': // 员工
      kvFileUrl = avatarQsyg
      break
    case 'I': // 员工
      kvFileUrl = iconHuaTi
      break
    case '7': // 出版物
    case 'E': // 出版物-科室
      kvFileUrl = imgBook
      break
    case 'Z-1': // 直播
    case 'Z-3': // 活动详情
      kvFileUrl = iconZhiBo
      break
    case 'Z-2': // 培训
    case 'L': // 培训详情
      kvFileUrl = iconPeiXun
      break
    case 'V': // 频道分类
      kvFileUrl = iconPinDaoFenLei
      break
    case 'W': // 频道
      kvFileUrl = iconPinDao
      break
    case 'z': // 频道默认
      kvFileUrl = iconPinDaoOther
      break
    case 'X': // 栏目
      kvFileUrl = iconLanMu
      break
    case 'Y': // 子栏目
      kvFileUrl = iconZiLanMu
      break
    case 'S': // 热图
      kvFileUrl = iconImg
      break
    case 'O': // 讨论组
      kvFileUrl = iconTaoLunZu
      break
    case '9': // 专辑
      kvFileUrl = iconZhuanJi
      break
    case '8': // 论文
      kvFileUrl = iconLunWen
      break
    default:
  }
  if (!type)  kvFileUrl = iconWaiLian
  return kvFileUrl
}

export const imgUrlToBase64 = (url) => new Promise((resolve, reject) => {
  if (!url) {
    reject('请传入url内容')
  }
  // 图片地址
  const image = new Image()
  // 设置跨域问题
  image.setAttribute('crossOrigin', 'anonymous')
  // 图片地址
  image.src = `${url}?time=${new Date().getTime()}`
  image.onload = () => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.width = image.width
    canvas.height = image.height
    ctx.drawImage(image, 0, 0, image.width, image.height)
    // 获取图片后缀
    const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
    // 转base64
    const dataUrl = canvas.toDataURL(`image/${ext}`, 1)
    resolve(dataUrl || '')
  }
})

// 术士处理
export const recursion = (data, depth = 3) => {
  const newData = []
  const dataCache = [...data]
  dataCache.forEach((item, index) => {
    const childList = (item?.operationModeList && item?.operationModeList.slice(0)) || []
    const overflowDepth = Number(item.level) + 1 > Number(depth)
    const hasChildList = childList.length > 0
    if (overflowDepth) {
      // 限制术式级联层级
      const list = { ...item }
      delete list.operationModeList // 防止出现空白列
      newData.push(list)
    } else if (hasChildList) {
      const modeList = recursion(item.operationModeList, depth)
      const hasChild = modeList.length > 0
      const list = { ...item, operationModeList: modeList }
      if (!hasChild) delete list.operationModeList // 防止出现空白列
      // 判断 hasChild ，限制如果没有子术士，则不显示父术式
      if (hasChild) newData.push(list)
    }
  })
  return newData
}

/*
* 计算元素中文字的行数
* el 元素容器
* */
export function computedTextRows (el, isAll = false) {
  if (!el) {
    return 0
  }
  const style = window.getComputedStyle(el, null)
  const elCss = {
    width: style.width,
    fontSize: style.fontSize,
    lineHeight: style.lineHeight,
    color: style.color,
    marginBottom: style.marginBottom,
    zIndex: -1,
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0
  }
  let text = el.innerText
  // console.log(elCss, text)
  const elCopy = document.createElement('p')
  elCopy.innerText = text
  for (let cssKey in elCss) {
    elCopy.style[cssKey] = elCss[cssKey]
  }
  document.body.appendChild(elCopy)
  // 计算得到元素高度然后删除元素
  const elCopyHeight = elCopy.clientHeight
  const elCopyLineHeight = parseInt(elCss.lineHeight)
  const elCopyMarginBottom = parseInt(elCss.marginBottom)
  // console.log(elCopyHeight, elCopyLineHeight, elCopyMarginBottom, 'elCopyMarginBottom===')
  document.body.removeChild(elCopy)
  let itemHeight = isAll ? elCopyLineHeight +  elCopyMarginBottom  : elCopyLineHeight
  const rows = Math.floor(elCopyHeight / itemHeight)
  return rows
}

export function  addPixelFn (url)  {
  let pixelImg = document.createElement('img')
  pixelImg.width = '0'
  pixelImg.height = '0'
  pixelImg.display = 'none'
  // 替换链接为 pixel 链接
  pixelImg.src = url
  // document.body 可以替换成某个元素
  document.body.appendChild(pixelImg)
}

export const commonJumpPublication = (params) => {
  switch (params.bookType) {
    case 1:
      history.push(`/publication-detail/book?publishId=${params.bookId}`)
      break
    case 2:
      history.push(`/publication-detail/paper?publishId=${params.bookId}`)
      break
    case 3:
      history.push(`/publication-detail/guide?publishId=${params.bookId}`)
      break
    case 4:
      history.push(`/publication-detail/consensus?publishId=${params.bookId}`)
      break
    default:
      history.go(0)
  }
}

export const commonJumpWxService = () => {
  window.location.href = process.env.REACT_APP_WX_SERVICE
}

export function getOpenAppParams (keys) {
  const queryKeys = keys || ['utm_user_type', 'utm_user_id', 'utm_share_type', 'utm_share_id']
  let params = {}
  queryKeys.forEach(key => {
    params[key] = getQueryString(key)
  })
  
  return params
}